import { Injectable } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of, throwError, catchError } from 'rxjs';

import { NotificationType, NotificationService } from '@core';
import { CookieboxService } from '../cookiebox.service';

@Injectable({
    providedIn: 'root',
})
export class CookieboxPrivacyStatementResolver {
    public constructor(
        private readonly cookieboxService: CookieboxService,
        private readonly router: Router,
        private readonly notificationService: NotificationService,
    ) {}
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<SafeHtml> {
        const privacyStatementUrl = route.data.privacyStatementUrl as string;

        if (!privacyStatementUrl) {
            return throwError(() => new Error('CookieboxPrivacyStatementResolver: Missing privacy statement url'));
        }

        return this.cookieboxService.fetch(privacyStatementUrl).pipe(
            catchError(() => {
                this.notificationService.notify(
                    'Datenschutzerklärung konnte nicht geladen werden.',
                    NotificationType.CRITICAL,
                );
                return of(this.router.createUrlTree(['/']));
            }),
        );
    }
}
